import Payments from './Payments'
import PaymentsHeader from './PaymentsHeader'
import PaymentsHelp from './PaymentsHelp'

export default {
  default: Payments,
  header: PaymentsHeader,
  help: PaymentsHelp,
}
